import { useCallback } from "react"

import { Flex, Space } from "antd"
import { useTranslation } from "react-i18next"

import DropdownBlockCheckbox from "../../../../Components/Filters/DropdownBlockCheckbox"
import DropdownDateBlock from "../../../../Components/Filters/DropdownDateBlock/DropdownDateBlock"
import { getCalculatedPeriod } from "../../../../Utils/utils"

export const ReferralFilterBlock = ({
  businessAccounts,
  filters,
  handleChangeFilter,
  isMobile
}) => {
  const { t } = useTranslation()

  const handleChangeCustomDate = useCallback((newFilters) => {
    if (newFilters["period"]) {
      handleChangeFilter(newFilters)
    } else {
      setTimeout(() => handleChangeFilter({ period: "30 days" }), 100)
    }
  }, [])

  return (
    <Flex gap={12} style={{ marginBottom: 24, flexDirection: isMobile && "column-reverse" }}>
      {businessAccounts && (
        <DropdownBlockCheckbox
          label="Account"
          id="business_accounts"
          withSearch
          dropdownFilters={filters?.business_accounts}
          setDropdownFilters={handleChangeFilter}
          allBtnText={"All"}
          data={businessAccounts}
          type="chart"
        />
      )}
      <Space.Compact size={"large"} style={{ width: isMobile && "100%" }}>
        {/*<Button*/}
        {/*  className={cls("compact-btn", {*/}
        {/*    active: filters?.period === "7 days",*/}
        {/*  })}*/}
        {/*  style={{width: isMobile && '100%'}}*/}
        {/*  onClick={() => handleChangeFilter({ period: "7 days" })}*/}
        {/*>*/}
        {/*  {t("7 days")}*/}
        {/*</Button>*/}
        {/*<Button*/}
        {/*  className={cls("compact-btn", {*/}
        {/*    active: filters?.period === "30 days",*/}
        {/*  })}*/}
        {/*  style={{width: isMobile && '100%'}}*/}
        {/*  onClick={() => handleChangeFilter({ period: "30 days" })}*/}
        {/*>*/}
        {/*  {t("30 days")}*/}
        {/*</Button>*/}
        {/*<Button*/}
        {/*  className={cls("compact-btn", { active: filters?.period === "all" })}*/}
        {/*  onClick={() => handleChangeFilter({ period: "all" })}*/}
        {/*  style={{width: isMobile && '100%'}}*/}
        {/*>*/}
        {/*  {t("All time")}*/}
        {/*</Button>*/}
        {!isMobile && (
          <div>
            <DropdownDateBlock
              id={"period"}
              customOverlayClassName={"dashboard-filters"}
              label={"Custom"}
              iconType={"calendar_days"}
              setDropdownFilters={handleChangeCustomDate}
              dropdownFilters={getCalculatedPeriod(filters?.period)}
              presetId={filters?.__preset_period}
              inactive={filters?.period?.type !== "custom"}
              alwaysShowLabel={false}
            />
          </div>
        )}
      </Space.Compact>

      {isMobile && (
        <DropdownDateBlock
          id={"period"}
          customOverlayClassName={"dashboard-filters"}
          label={"Custom"}
          iconType={"calendar_days"}
          setDropdownFilters={handleChangeCustomDate}
          dropdownFilters={getCalculatedPeriod(filters?.period)}
          presetId={filters?.__preset_period}
          inactive={filters?.period?.type !== "custom"}
          alwaysShowLabel={false}
        />
      )}
    </Flex>
  )
}
